<h1 class="mf-popup-title" i18n>Urejanje listine</h1>
<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content">
            <div class="row">
                <div class="col mf-content-portfolio-overflow">
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text" i18n>Novo ime listine</h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body mf-portlet-custome__body">
                            <input [formControl]="fcFileName" type="text" class="form-control m-input" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer mf-custom-footer">
    <button
        (click)="activeModal.close(undefined)"
        type="button"
        style="width: 150px"
        class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom"
        i18n="@@cancel"
    >
        Prekliči
    </button>
    <button
        [disabled]="!fcFileName.valid || (isLoading$ | async)"
        (click)="onRenameClick()"
        type="submit"
        style="width: 150px"
        class="mr-auto btn m-btn--pill btn-accent m-btn"
    >
        <ng-container *ngIf="isLoading$ | async; else buttonText">
            <div class="d-flex align-items-center justify-content-center">
                <div class="m-loader m-loader--brand loader-size"></div>
                <span class="pl-2">Nalagam...</span>
            </div>
        </ng-container>
        <ng-template #buttonText><span>Preimenuj</span></ng-template>
    </button>
</div>
